export default __webpack_public_path__ + "static/media/FeatureFlag.447389c7.svg";